// src/services/dataLayerHub.service.ts
import { IDateTimeEvent, IUserProgramSelection, IUserSelections } from '@/components/pages/event-reg-refresh/App/models/event-reg-refresh-models';
import { pushEcomGTMEvent } from './functions/push-Ecom-GTM-event.function';


export const EcomDataLayerHub = {
    
    viewProgramSelection: (pageTitle: string) => {
        pushEcomGTMEvent({
        event: 'view_program_selection',
        page_title: pageTitle,
        });
    },

    filterPrograms: (industryFilter: string, deliveryfilter: string, trainingTypeFilter: string) => {
        pushEcomGTMEvent({
        event: 'filter_programs',
        filter_name: industryFilter,
        filter_value: deliveryfilter,
        training_type_filter: trainingTypeFilter,
        });
    },

    searchPrograms: (searchTerm: string) => {
        pushEcomGTMEvent({
        event: 'search_programs',
        search_term: searchTerm,
        });
    },

    programCompareClick: (programName: string) => {
        pushEcomGTMEvent({
        event: 'program_compare_click',
        program_name: programName,
        });
    },

    viewProgramCompare: (comparedPrograms: string[]) => {
        pushEcomGTMEvent({
        event: 'view_program_compare',
        compared_programs: comparedPrograms,
        });
    },

    selectProgram: (programName: string, programId: string, deliveryType: string) => {
        pushEcomGTMEvent({
        event: 'select_program',
        program_name: programName,
        program_id: programId,
        delivery_type: deliveryType,
        });
    },

    viewAddons: (selectedProgram: string, availableAddons: IUserProgramSelection) => {
        pushEcomGTMEvent({
        event: 'view_addons',
        selected_program: selectedProgram,
        available_addons: availableAddons,
        });
    },

    selectAddon: (addonName: string, addonPrice: number) => {
        pushEcomGTMEvent({
        event: 'select_addon',
        addon_name: addonName,
        addon_price: addonPrice,
        });
    },

    continueToDateTime: (fromStep: string, toStep: string) => {
        pushEcomGTMEvent({
        event: 'continue_to_date_time',
        from_step: fromStep,
        to_step: toStep,
        });
    },

    viewDateTime: (programName: string) => {
        pushEcomGTMEvent({
        event: 'view_date_time',
        program_name: programName,
        });
    },

    selectSession: (sessionData: IDateTimeEvent,deliveryType: string) => {
        pushEcomGTMEvent({
        event: 'select_session',
        session_data: sessionData,
        delivery_type: deliveryType,
        });
    },

    viewAttendeeForm: (numAttendeesDefault: number) => {
        pushEcomGTMEvent({
        event: 'view_attendee_form',
        num_attendees_default: numAttendeesDefault,
        });
    },

    modifyAttendees: (actionType: 'Add' | 'Remove') => {
        pushEcomGTMEvent({
        event: 'modify_attendees',
        action_type: actionType,
        });
    },

    attendeeFormInput: (fieldName: string, completionPercent: number) => {
        pushEcomGTMEvent({
        event: 'attendee_form_input',
        field_name: fieldName,
        completion_percent: completionPercent,
        });
    },

    viewReviewSelection: (selectedPrograms: IUserProgramSelection, totalPrice: number) => {
        pushEcomGTMEvent({
        event: 'view_review_selection',
        selected_programs: selectedPrograms,
        total_price: totalPrice,
        });
    },

    reviewEditClick: (editSection: 'Program' | 'Attendee') => {
        pushEcomGTMEvent({
        event: 'review_edit_click',
        edit_section: editSection,
        });
    },

    confirmEnrollment: (userSelections:IUserSelections, totalCost:number) => {
        pushEcomGTMEvent({
        event: 'confirm_enrollment',
        confirmed_programs: userSelections.userProgramSelection,
        confirmed_addons: userSelections.userAddOnProgramSelections,
        total_cost: totalCost,
        });
    },

    enrollmentComplete: (transactionId: string, numAttendees: number, programsEnrolled: string[]) => {
        pushEcomGTMEvent({
        event: 'enrollment_complete',
        transaction_id: transactionId,
        num_attendees: numAttendees,
        programs_enrolled: programsEnrolled,
        });
    },
};
